module.exports = __webpack_public_path__ + "static/media/thomas-kelley-5YtjgRNTli4-unsplash.61529a5f.jpg";